module.exports = __webpack_public_path__ + "media/assets/images/header-914e0d4c83ea0f9249b41cbd3177b12c.svg";